
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutorials/import-figma-in-canva-using-plugin",
      function () {
        return require("private-next-pages/tutorials/import-figma-in-canva-using-plugin.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutorials/import-figma-in-canva-using-plugin"])
      });
    }
  